module.exports = __webpack_public_path__ + "static/img/14.7b93eaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/14.png
// module id = CpPz
// module chunks = 0